import Carousel from 'react-bootstrap/Carousel';
const MainCarousel = () => {
    const CustomPrevIcon = (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      );
      
      const CustomNextIcon = (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      );      
    return (
        <>
            <Carousel id="carousel_main" prevIcon={CustomPrevIcon} nextIcon={CustomNextIcon}>
            {/* <Carousel id="carousel_main"> */}
                {/* <Carousel.Item className="carousel-1">
                    <div className="carousel-caption-wrapper-1">
                        <h3>화물넘버 직거래 플랫폼
                            <span className='red'>탑</span>
                            <span className='blue'>탑</span>
                            <br/>Grand Open
                        </h3>
                        <h4>화물차 영업용 넘버, 주선면허<br />
                            사는 것 부터 파는 것 까지</h4>
                    </div>
                </Carousel.Item> */}
                {/* <Carousel.Item className="carousel-1">
                    <div className="carousel-caption-wrapper-1">
                        <h3 style={{margin:0}}>한가위 맞이</h3>
                        <h3>
                            <span className='blue font-style-normal'>서류 대행</span>
                            <span className='red font-style-normal'>50% 할인</span>
                            <span className='blue font-style-normal'>이벤트</span>
                        </h3>
                        <h5>
                            <ul>
                                <li>일시 : 8월 ~ 9월 (60일)</li>
                                <li>대상 : 서울, 경기, 인천 수도권</li>
                                <li>내용 : 서류 대행 수수료 50% 할인</li>
                            </ul>
                        </h5>
                    </div>
                </Carousel.Item> */}
                <Carousel.Item className="carousel-2">
                    <div className="carousel-caption-wrapper-2">
                        <h3>안전한 번호판 직거래 플랫폼 
                            <span className='red'>탑</span>
                            <span className='blue'>탑</span>
                        </h3>
                        <h4>모든 번호판을 안심하고 거래할 수 있도록</h4>
                    </div>
                </Carousel.Item>
                <Carousel.Item className="carousel-3">
                    <div className="carousel-caption-wrapper-3">
                        <h5>언제 어디서나 쉽고 빠른</h5>
                        <h3>내 손안의 플랫폼 
                            <span className='red'>탑</span>
                            <span className='blue'>탑</span>
                        </h3>
                        <h4>PC에서도 모바일에서도<br />
                            어디서든 빠른 거래가 가능한</h4>
                    </div>
                </Carousel.Item>
            </Carousel>
        </>
    );
}
export default MainCarousel;